export enum WeightClassificationEnum {
	LIGHTWEIGHT = 1,
	PROPERWEIGHT = 2,
	OVERWEIGHT = 3,
}
